import React from "react";

import { getPrice } from "../../../../util";

import "./index.scss";

const Services = ({ services, dealerLocation, t }) => {
  if (!services?.length) return null;

  const hasPrices = services.some(s => s.price);
  const showIncludingVat = Boolean(dealerLocation?.include_vat);

  return (
    <div className="kiosk-comm-services">
      <div className="kiosk-comm-services-header">
        <span className="kiosk-comm-services-col-title">{t("cc_title").message || "Title"}</span>
        <span className="kiosk-comm-services-col-remarks">{t("cc_remarks").message || "Remarks"}</span>
        {hasPrices && (
          <span className="kiosk-comm-services-col-price">
            {showIncludingVat ? t("cc_price_inc_vat").message || "Price (incl. VAT)" : t("cc_price_excl_vat").message || "Price (excl. VAT)"}
          </span>
        )}
      </div>

      <div className="kiosk-comm-services-body">
        {services.map((service, index) => (
          <div className="kiosk-comm-service" key={index}>
            <span className="kiosk-comm-service-title">{service.title}</span>
            <span className="kiosk-comm-service-remark">{service.description || ""}</span>
            {hasPrices && <span className="kiosk-comm-service-price">{getPrice(service.price, dealerLocation)} €</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
